import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { AllocatedFileNumberDetails, AllocatedFileNumberDetailsResponse } from '../../models/contractNum.model';
import { BillingService } from '../../services/billing.service';
import { UtilityService } from '../../services/shared/utility.service';

@Component({
    selector: 'app-allocated-file-numbers-list',
    templateUrl: './allocated-file-numbers-list.component.html',
    styleUrls: ['./allocated-file-numbers-list.component.css']
})
/** allocated-file-numbers-list component*/
export class AllocatedFileNumbersListComponent implements OnInit {
    displayedColumns = ['inventionName', 'assignedFileNumber', 'completeFileNumber', 'assignedDate'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatInput) search: MatInput;
    dataSource = new MatTableDataSource([]);
    pageSize: any;
    pageEvent: any = PageEvent;
    clpUserId: number = 0;
    patentId: number = 0;
    allocatedFileNumberDetailsList: AllocatedFileNumberDetails[];
    clpUserNameList: AllocatedFileNumberDetails[] = [];
    allocatedFileNumberDetailsResponse: AllocatedFileNumberDetailsResponse;
    isLoading: boolean = false;
    encryptedUser: string = "";

    /** allocated-file-numbers-list ctor */
    constructor(private _route: ActivatedRoute,
        private _billingService: BillingService,
        private _utilityService: UtilityService) {
    }

    ngOnInit(): void {
        this.loadAllocatedFileNumberDetails();
    }

    private async loadAllocatedFileNumberDetails() {
        this.isLoading = true;
        this._route.paramMap.subscribe(async params => {
            if (params.has('clpuserid')) {
                this.clpUserId = +params.get('clpuserid');
                if (params.has('patentId')) {
                    this.patentId = +params.get('patentId');
                }

                await this._billingService.getAllocatedFileNoDetailsAsync(this.encryptedUser, this.clpUserId, this.patentId)
                    .then(async (result: AllocatedFileNumberDetailsResponse) => {
                        if (result) {
                            if (result.statusCode == 0) {
                                this.allocatedFileNumberDetailsList = UtilityService.clone(result.allocatedFileNumberDetailsList);
                                const ELEMENT_DATA: AllocatedFileNumberDetails[] = this.allocatedFileNumberDetailsList;
                                this.allocatedFileNumberDetailsList.forEach((clpuser) => {
                                    if (!this.clpUserNameList.some((u) => u.clpUserId === clpuser.clpUserId)) {
                                        this.clpUserNameList.push(clpuser);
                                    }
                                });
                                this.clpUserNameList.sort((a, b) => a.clpUserName.localeCompare(b.clpUserName));
                                if (localStorage.getItem('allocatedfileNumberList_PageSize')) {
                                    let pageSizeVal: string = "";
                                    pageSizeVal = localStorage.getItem('allocatedfileNumberList_PageSize');
                                    this.paginator.pageSize = parseInt(pageSizeVal);
                                } else
                                    this.paginator.pageSize = 5;
                                this.dataSource = new MatTableDataSource(ELEMENT_DATA);
                                this.dataSource.sort = this.sort;
                                this.dataSource.paginator = this.paginator;
                                this.applyFilter(this.search.value);
                            } else {
                                this._utilityService.handleError(result.statusCode, result.errorMsg);
                            }
                            this.isLoading = false;
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.isLoading = false;
                        this._utilityService.handleErrorResponse(err);
                    });
            }
        });
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
        //this.dataSource.filterPredicate = (data: any, filter: string): boolean => {
        //    return String(data.assignedFileNumber).includes(filter);
        //};
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    public handlePage(e: any) {
        localStorage.setItem('allocatedfileNumberList_PageSize', e.pageSize);
    }

    filterFileNumberList(clpUserId: string) {
        if (+clpUserId === 0) {
            const ELEMENT_DATA: AllocatedFileNumberDetails[] = this.allocatedFileNumberDetailsList;
            this.dataSource = new MatTableDataSource(ELEMENT_DATA);

        }
        else {
            const ELEMENT_DATA: AllocatedFileNumberDetails[] = this.allocatedFileNumberDetailsList.filter(clpuser => clpuser.clpUserId === +clpUserId);
            this.dataSource = new MatTableDataSource(ELEMENT_DATA);
        }
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }
}
